import { ICardEdit } from "../../services/operaciones/model/ICardEdit";

const fieldsToClass = (card: ICardEdit | undefined | null, field: string) => {
  if (!card) return undefined;
  let obj : any = {};
  
  const fields = Object.keys(card).filter(p => p.startsWith(`${field}.`));

  fields.filter(p => p.startsWith(field)).forEach(fld => {
    const fldName = fld.substring(`${field}.`.length);
    obj[fldName] = (card as any)[fld];
  });

  console.log("fieldsToClass", field, obj)
  return Object.keys(obj).length >= 1 ? obj : undefined;
}

const fieldsToArray = (card: ICardEdit | undefined | null, field: string) => {
  if (!card) return undefined;
  const res = [];
  const fields = Object.keys(card).filter(p => p.startsWith(`${field}[`));
  let i = 0;
  do {
    const fieldIndex = `${field}[${i}]`;    
    if (!fields.find(p => p.startsWith(fieldIndex))) 
      break;

    const obj = fieldsToClass(card, fieldIndex);

    res.push(obj);
    i++;
  } while(true);

  console.log("fieldsToArray", field, res)
  return res;
}

export { fieldsToClass, fieldsToArray }